import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateProductSpecification($companyId: ID!, $attributes: ProductSpecificationAttributes!) {
    createProductSpecification(companyId: $companyId, attributes: $attributes) {
      productSpecification {
        id
        ...CreatedProductSpecification
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedProductSpecification on ProductSpecification {
    id
    value
    specification {
      id
      name
    }
  }
`
